import { render, staticRenderFns } from "./CaptureTaskView.vue?vue&type=template&id=66a5e86b&"
import script from "./CaptureTaskView.vue?vue&type=script&lang=js&"
export * from "./CaptureTaskView.vue?vue&type=script&lang=js&"
import style0 from "./CaptureTaskView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports